import {FullVehicle} from '@dms/api/shared';

/**
 * Transforms vehicle data for cloning by clearing unique identifiers and registration/warranty fields.
 * Preserves reusable data (make, model, features) and physical properties (seatCount).
 */
export const transformVehicleForCloning = (vehicle: FullVehicle): FullVehicle => {
  const {modelSpecification, ...rest} = vehicle;

  return {
    ...rest,
    vin: null,
    state: null,
    modelSpecification: {
      originCountry: null,
      firstRegistrationCountry: null,
      lastRegistrationCountry: null,
      warrantyDate: null,
      warrantyMileage: null,
      isRegistered: null,
      serviceContractUntil: null,
      serviceContractMileageLimit: null,
      serviceContractNote: null,
      seatCount: modelSpecification?.seatCount,
    },
  } as FullVehicle;
};
